export interface UsersTabProps {
  className?: string;
}

export enum UsersStatus {
  TOTAL = 'TOTAL',
  ACTIVE = 'ACTIVE',
  DEACTIVATE = 'DEACTIVATE',
  PENDING = 'PENDING',
}
